import { initProductBuyTile } from '../../../snippets/product-buy-tile-control/product-buy-tile-control';

export const initControlsSectionTiles = () => {
  const controlProductEls = document.querySelectorAll(
    '[data-list-collections-controls-product]'
  );

  controlProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-controls-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
